// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap__xneUn3T0pPs6I","text":"text__MYtbQBw9Yl0jH"};